import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Headers, ResponseContentType } from '@angular/http';
import { InterceptorService } from 'ng2-interceptors';
import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class AdditionalDocsService {

    private headers = new Headers({'Content-Type': 'application/json'});

    constructor(private http: InterceptorService) { }

    getDocNames(): Promise<any> {
        return this.http.post(environment.apiUrl + 'site-api/list-dairy-additional-docs', {}, {headers: this.headers})
            .toPromise()
            .then(
                function(response) {
                    return response.json();
                }
            )
            .catch(this.handleError);
    }

    getDoc(docName: string): Observable<any> {
        const options = {
            headers: this.headers,
            responseType: ResponseContentType.Blob
        };

        const params = {
            'docName': docName
        };
        return this.http.post(environment.apiUrl + 'site-api/get-dairy-additional-doc', JSON.stringify(params), options)
            .map(
                function(response) {
                    return response.blob();
                }
            )
            .catch(this.handleError);
        ;
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// ./src/app/additional-docs/additional-docs.service.ts